import styled, { css } from 'styled-components'
import type { FunctionComponent, HTMLAttributes } from 'react'
import Paragraph from '../Paragraph/Paragraph'
import Button, { Variant } from '../Button/Button'
import Icon from '../Icon/Icon'

const StyledParagraph = styled(Paragraph)`
  margin: 0 0 1.5rem;
`

const ErrorMessageStyle = styled.div`
  ${({ absolute }: { absolute: boolean }) =>
    absolute &&
    css`
      position: absolute;
      top: 3.5rem;
      left: 50%;
      transform: translateX(-50%);

      @media screen and (min-width: 48rem) {
        top: 50%;
        transform: translateX(-50%) translateY(-50%);
      }
    `}

  z-index: 1;
  background-color: white;
  padding: 1.25rem;
  border: 1px solid var(--greyLight);
  text-align: center;
`

export interface ErrorMessageProps {
  message: string
  buttonOnClick: () => void
  buttonLabel: string
  buttonIcon?: React.ReactNode
  absolute?: boolean
}

const ErrorMessage: FunctionComponent<ErrorMessageProps & HTMLAttributes<HTMLDivElement>> = ({
  message,
  buttonLabel,
  buttonOnClick,
  buttonIcon,
  absolute = false,
  ...otherProps
}) => (
  <ErrorMessageStyle absolute={absolute} {...otherProps} data-testid="errorMessage">
    <StyledParagraph small>{message}</StyledParagraph>
    <Button
      type="button"
      data-testid="buttonReload"
      onClick={buttonOnClick}
      variant={Variant.Primary}
    >
      <Icon size={16}>{buttonIcon}</Icon>
      {buttonLabel}
    </Button>
  </ErrorMessageStyle>
)

export default ErrorMessage
